<div class="card carddborder">
  <div class="card-header">
    <div class="launch-header">
      <button class="btn btn-light" (click)="back()"><i class="fa fa-angle-left"></i> Dashboard</button>
      <h5 class="mb-0">EKS Request Review</h5>
    </div>
  </div>

  <div class="card-body">
    <div *ngIf="loading" class="mapping-box">Loading request details...</div>
    <div *ngIf="!loading && error" class="alert alert-danger mb-3">{{ error }}</div>

    <ng-container *ngIf="!loading && data">
      <div class="mapping-box mb-3">
        <div class="mapping-title">Request Summary</div>
        <table class="table table-sm mb-0">
          <tbody>
            <tr *ngFor="let row of summaryRows">
              <td><strong>{{ row.label }}</strong></td>
              <td>
                <span *ngIf="row.display.type === 'text'">{{ row.display.text }}</span>
                <div *ngIf="row.display.type === 'list'">{{ row.display.items.join(", ") || "-" }}</div>
                <div *ngIf="row.display.type === 'pairs'">
                  <div *ngFor="let pair of row.display.pairs" class="mb-1">
                    <strong>{{ pair.key }}:</strong>
                    <span *ngIf="!pair.isNested"> {{ pair.value }}</span>
                  </div>
                </div>
                <div *ngIf="row.display.type === 'object-list'">
                  <div *ngFor="let item of row.display.items; let i = index" class="mapping-box mb-2 p-2">
                    <div class="mapping-subtitle mb-1">Item {{ i + 1 }}</div>
                    <div *ngFor="let pair of item" class="mb-1">
                      <strong>{{ pair.key }}:</strong> {{ pair.value }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="mapping-box mb-3">
        <div class="mapping-title">EKS Request Details</div>
        <table class="table table-sm mb-0">
          <tbody>
            <tr *ngFor="let row of payloadRows">
              <td><strong>{{ row.label }}</strong></td>
              <td>
                <span *ngIf="row.display.type === 'text'">{{ row.display.text }}</span>
                <div *ngIf="row.display.type === 'list'">{{ row.display.items.join(", ") || "-" }}</div>
                <div *ngIf="row.display.type === 'pairs'">
                  <div *ngFor="let pair of row.display.pairs" class="mb-1">
                    <strong>{{ pair.key }}:</strong>
                    <span *ngIf="!pair.isNested"> {{ pair.value }}</span>
                  </div>
                </div>
                <div *ngIf="row.display.type === 'object-list'">
                  <div *ngIf="row.label === 'Tags'" class="tags-list">
                    <div *ngFor="let item of row.display.items" class="mapping-box mb-2 p-2">
                      <div class="tag-line">
                        <strong>key:</strong> {{ getTagKey(item) }}
                        <strong class="ml-2">value:</strong> {{ getTagValue(item) }}
                      </div>
                    </div>
                  </div>
                  <div *ngIf="row.label !== 'Tags'">
                    <div *ngFor="let item of row.display.items; let i = index" class="mapping-box mb-2 p-2">
                      <div class="mapping-subtitle mb-1">Item {{ i + 1 }}</div>
                      <div *ngFor="let pair of item" class="mb-1">
                        <strong>{{ pair.key }}:</strong>
                        <span *ngIf="!pair.isNested"> {{ pair.value }}</span>
                        <div *ngIf="pair.isNested && pair.value.type === 'list'" class="mt-1">
                          {{ pair.value.items.join(", ") || "-" }}
                        </div>
                        <div *ngIf="pair.isNested && pair.value.type === 'pairs'" class="mt-1 pl-2">
                          <div *ngFor="let nestedPair of pair.value.pairs" class="mb-1">
                            <strong>{{ nestedPair.key }}:</strong> {{ nestedPair.value }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="step-footer request-actions" *ngIf="showApproveRejectButtons">
        <button class="btn btn-success action-btn" [disabled]="actionLoading" (click)="onApprove()">
          {{ actionLoading ? "Please wait..." : "Approve" }}
        </button>
        <button class="btn btn-danger action-btn" [disabled]="actionLoading" (click)="onReject()">
          {{ actionLoading ? "Please wait..." : "Reject" }}
        </button>
      </div>
      <div *ngIf="actionMessage" class="alert alert-success mt-2 mb-0">{{ actionMessage }}</div>
      <div *ngIf="actionError" class="alert alert-danger mt-2 mb-0">{{ actionError }}</div>

      <!-- Reason Modal -->
      <div class="ng-modal-backdrop" *ngIf="showReasonModal">
        <div class="ng-modal-card" style="max-width: 500px; width: 100%;">
          <div class="nodegroup-modal-header">
            <div class="eks-request-modal-title">
              <div class="eks-request-modal-icon">
                <i class="fa" [ngClass]="modalAction === 'approve' ? 'fa-check text-success' : 'fa-times text-danger'"></i>
              </div>
              <div>
                <h5>{{ modalAction === 'approve' ? 'Approve' : 'Reject' }} EKS Request</h5>
                <div class="eks-request-modal-subtitle">
                  Please provide a reason to {{ modalAction }} this request
                </div>
              </div>
            </div>
            <button type="button" class="eks-request-modal-close" aria-label="Close popup" (click)="closeReasonModal()">
              <i class="fa fa-times"></i>
            </button>
          </div>

          <div class="nodegroup-modal-body">
            <div class="mb-3">
              <label>Reason <span class="required-star">*</span></label>
              <textarea class="form-control" [(ngModel)]="reasonText" rows="3" placeholder="Enter reason..."></textarea>
              <div *ngIf="reasonError" class="text-danger small mt-1">{{ reasonError }}</div>
            </div>
          </div>

          <div class="nodegroup-modal-footer">
            <button class="btn btn-light" [disabled]="actionLoading" (click)="closeReasonModal()">
              Cancel
            </button>
            <div class="eks-request-footer-meta"></div>
            <button class="btn" [ngClass]="modalAction === 'approve' ? 'btn-success' : 'btn-danger'" [disabled]="actionLoading" (click)="submitDecision()">
              {{ actionLoading ? "Please wait..." : (modalAction === 'approve' ? 'Approve' : 'Reject') }}
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
